import { Box, Text, Spacer, Grid, Loader } from "@flexisaf/flexibull2";
import QuizathonEmptyState from "../../../components/custom/QuizathonEmptyState";
import styled from "styled-components";
import useSingleQuizathonGet from "../../../hooks/quizathon/useSingleQuizathon";
import { useParams } from "react-router-dom";
import moment from "moment";
import Theme from "../../../theme";
import { thousandFormatter } from "../../../utils/helpers";

const QuizathonInformation = () => {
  const { id } = useParams();
  const { singleQuizathon, loadingSingleQuizathon } = useSingleQuizathonGet({
    id,
  });

  return (
    <Container>
      <Spacer space="15px" />
      {loadingSingleQuizathon ? (
        <Loader color={Theme.PrimaryColor} section />
      ) : singleQuizathon ? (
        <Grid default="1fr 1fr" gap="1.3rem" className="preview-container">
          <Box>
            <Text bold>Quizathon Title</Text>
            <Spacer space="5px" />
            <Box className="label-preview">
              <Text style={{ color: "#61759B" }}>{singleQuizathon?.title}</Text>
            </Box>
          </Box>

          <Box />

          <Box>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Text bold>Quizathon Start Date</Text>
              <Text bold>Quizathon End Date</Text>
            </Box>
            <Spacer space="5px" />
            <Box className="label-preview">
              <Text style={{ color: "#61759B" }}>
                {" "}
                <i className="saf-calendar-1" />{" "}
                {moment(singleQuizathon?.startAt).format("YYYY-MM-DD")}
              </Text>
              <Box className="line" />
              <Text style={{ color: "#61759B" }}>
                {" "}
                <i className="saf-calendar-1" />{" "}
                {moment(singleQuizathon?.stopAt).format("YYYY-MM-DD")}
              </Text>
            </Box>
          </Box>

          <Box>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Text bold>Quizathon Start Time</Text>
              <Text bold>Quizathon End Time</Text>
            </Box>
            <Spacer space="5px" />
            <Box className="label-preview">
              <Text style={{ color: "#61759B" }}>
                {" "}
                <i className="saf-clock" />{" "}
                {moment(singleQuizathon?.startAt).format("hh:mm A")}
              </Text>
              <Box className="line" />
              <Text style={{ color: "#61759B" }}>
                {" "}
                <i className="saf-clock" />{" "}
                {moment(singleQuizathon?.stopAt).format("hh:mm A")}
              </Text>
            </Box>
          </Box>

          <Box>
            <Text bold>Date Created</Text>
            <Spacer space="5px" />
            <Box className="label-preview">
              <Text style={{ color: "#61759B" }}>
                {moment(singleQuizathon?.createdAt).format("YYYY-MM-DD")}
              </Text>
            </Box>
          </Box>
          <Box>
            <Text bold>Maximum Participant Allowed</Text>
            <Spacer space="5px" />
            <Box className="label-preview">
              <Text style={{ color: "#61759B" }}>
                {thousandFormatter(singleQuizathon?.maxParticipants)}
              </Text>
            </Box>
          </Box>
          <Spacer space="30px" />
        </Grid>
      ) : (
        <QuizathonEmptyState title="No Data Found" />
      )}
    </Container>
  );
};

export default QuizathonInformation;

export const Container = styled(Box)`
  background-color: #fff;
  & .label-preview {
    background-color: #f7f9fa;
    padding: 0.9rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.2rem;
  }
  & .preview-container {
    padding: 1rem;
    max-width: 1024px;
  }
  & .line {
    background-color: #6c7072;
    width: 14px;
    height: 2px;
  }
`;
